import { ParcelaAcordo } from "core/features/acordo/typings";
import moment from "moment";

export function getSituacaoParcelaText(parcela: ParcelaAcordo) {
  const isAtrasado = moment(parcela.dataVencimento).isBefore(
    moment().format("YYYY-MM-DD")
  );

  const isRenegociado = !!parcela.dataRenegociacao;

  const isDeletado = parcela.deletedAt;

  const isPendente =
    !parcela.valorPago && !isAtrasado && !isRenegociado && !isDeletado;

  const _isAtrasado =
    !parcela.valorPago && isAtrasado && !isRenegociado && !isDeletado;

  if (parcela.valorPago) {
    return "Pago";
  } else if (isRenegociado) {
    return "Renegociado";
  } else if (isPendente) {
    return "Pendente";
  } else if (_isAtrasado) {
    return "Atrasado";
  } else if (isDeletado) {
    return "Cancelada";
  }

  return "";
}
